import { isNonNullable } from '@ipfabric/utils';
import { nullable } from '@ipfabric/utils/fp/nullable';
import { prop } from '@ipfabric/utils/fp/prop';
import type { ApiTableMergedState } from 'components/ApiTable/model/ApiTableModel';
import type { TableRowIdValue } from 'components/Table/model/TableModel';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import type { SparseArray } from 'utils/types/SparseArray';

export const selectPatchedData: (
  s: ApiTableMergedState,
) => SparseArray<unknown> = createScopedSelector(() =>
  createSelector(
    prop('data'),
    prop('dataPatch'),
    prop('rowIdField'),
    (data, patch, rowIdField) =>
      isNonNullable(patch) && isNonNullable(rowIdField)
        ? data.map(
            nullable.map((row: NonNullable<unknown>) => {
              const rowId = (row as Record<string, unknown>)[
                rowIdField
              ] as TableRowIdValue;
              if (isNonNullable(rowId) && rowId in patch) {
                return {
                  ...row,
                  ...patch[rowId],
                };
              }
              return row;
            }),
          )
        : data,
  ),
);
